// frameの一覧取得
export const FRAME_INDEX_PARAMS = {
  offset: 0,
  limit: 2000,
}